import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ViewEmployeeVoicePage } from './view-employee-voice.page';

const routes: Routes = [
  {
    path: '',
    component: ViewEmployeeVoicePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ViewEmployeeVoicePageRoutingModule {}
